module.exports = __webpack_public_path__ + "f64b362.webp";